import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding
} from '@angular/core';

export type TitlePosition = 'start' | 'center';

@Component({
  selector: 'td-wb-page-header',
  templateUrl: 'page-header.component.html',
  styleUrls: ['page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  @Input() position: TitlePosition = 'start';
  @Input() forceCenter: boolean = false;
  @Input() toolbarItemOffset: number = 0;

  @HostBinding('class.td-wb-page-header--center')
  get isCentered(): boolean {
    return this.position === 'center';
  }

  @HostBinding('class.td-wb-page-header--force-center')
  get isMobileCentered(): boolean {
    return this.forceCenter === true;
  }

  @HostBinding('class.td-wb-page-header--toolbar-offset--one')
  get isToolbarOffsetOne(): boolean {
    return this.toolbarItemOffset === 1;
  }

  @HostBinding('class.td-wb-page-header--toolbar-offset--two')
  get isToolbarOffsetTwo(): boolean {
    return this.toolbarItemOffset === 2;
  }

  @HostBinding('class.td-wb-page-header--toolbar-offset--three')
  get isToolbarOffsetThree(): boolean {
    return this.toolbarItemOffset === 3;
  }

  @HostBinding('class.td-wb-page-header--toolbar-offset--four')
  get isToolbarOffsetFour(): boolean {
    return this.toolbarItemOffset === 4;
  }
}

